<template>
  <div>
    <p class="text-center" style="margin-bottom:12px;">全部预约记录</p>
    <el-card v-for="appoint in pr.results" :key="appoint.id" class="box-card" @click.native ="enterAppoint(appoint)">
      <div slot="header">
        <el-row :gutter="10" v-if="appoint.room" >
          <el-col :span="8" style="text-align:right;">咨询时间</el-col>
          <el-col :span="16" style="text-align:left;font-weight:bold;">{{appoint.planDate}} {{appoint.planStartTime}}-{{appoint.planEndTime}}</el-col>
        </el-row>        
      </div>      
      <div class="teacherInfo relative" >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-avatar
              v-if="appoint.teacher"
              shape="square"
              :size="60"
              :src="appoint.teacher.headImage"
            ></el-avatar>            
          </el-col>
          <el-col :span="19">
            <el-row :gutter="10" v-if="appoint.room" style="margin:10px;">
              <el-col :span="8" style="text-align:right;">咨询地点</el-col>
              <el-col :span="16" style="text-align:left;font-weight:bold;">{{appoint.room.address}}</el-col>
            </el-row>
            <el-row :gutter="10" v-if="appoint.teacher" style="margin:10px;">
              <el-col :span="8" style="text-align:right;">咨询师</el-col>
              <el-col :span="16" style="text-align:left;font-weight:bold;">{{appoint.teacher.teacherName}}</el-col>
            </el-row>               
          </el-col>
          <el-col :span="1">
            <i class="el-icon-arrow-right" style="font-size:16px;"></i>                
          </el-col>                    
        </el-row>
      </div>
      <div class="clear mt10">
        <p class="text-center" style="margin-bottom:0px;">{{diff(appoint)}}</p>
        <p class="text-center" :class="getStatusClass(appoint.label)">{{parseAppointStatus(appoint.status)}}</p>
      </div>
    </el-card>
    <el-pagination @current-change="currentPageChange"
      :page-size="pageSize"
      :pager-count="5"
      layout="total, prev, pager, next"
      :total="pr.totalCount">
    </el-pagination>     
  </div>
</template>

<script>
import { mapState } from "vuex";
import HttpRequest from "@/utils/request";
import { diff24HourLater,diffAppointStart } from "@/utils/date.js";
import { parseAppointStatus,getStatusClass } from "@/utils/status.js";
export default {
  data() {
    return {
      pr: {},
      pageNo: 1,//当前页
      pageSize: 3,       
      //
      diff24HourLater,
      diffAppointStart,
      parseAppointStatus,
      getStatusClass,
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },    
  mounted() {
    document.title = '预约记录'
    this.getPageAppointByWhile();
  },
  methods: {       
    diff(appoint){
      if(appoint.status ==18){  
        return diff24HourLater(appoint.planCreateTime);
      }      
      if(appoint.status ==20){
        let datePlan = new Date(appoint.planDate+ ' ' + appoint.planStartTime);
        let timePlan = datePlan.getTime();      
        return diffAppointStart(timePlan);
      }
    },
    enterAppoint(appoint) {
      console.info('enterAppoint appoint.id/status：'+ appoint.id + '/' + appoint.status)
      if(appoint.status == 18)
        this.$router.push('/appointReserve?scheduleId=' + appoint.id + '&pathfrom=appointView')
      else if (appoint.status == 20 || appoint.status == 40)
        this.$router.push('/appointWait?scheduleId=' + appoint.id + '&pathfrom=appointView')
      else if (appoint.status == 31 || appoint.status == 36 || appoint.status == 51 || appoint.status == 56)
        this.$router.push('/appointCancel?scheduleId=' + appoint.id + '&pathfrom=appointView')       
      else if (appoint.status == 80 || appoint.status == 82 || appoint.status == 88 || appoint.status == 90)
        this.$router.push('/appointFinished?scheduleId=' + appoint.id + '&pathfrom=appointView')             
    },
    getPageAppointByWhile() {
      let url = "/constub/getPageAppointByWhile";
      let data = { token: this.student.token, pageNo: this.pageNo, pageSize: this.pageSize };
      HttpRequest.requestFormPost(url, data).then((res) => {
        if (res && res.result.success) {
          this.pr = res.data;
        } else {
          this.$alert(res.result.message,  {
            confirmButtonText: '确定',
            showClose: false,
          });  
        }
      });
    },
    currentPageChange(currentPage){
      this.pageNo = currentPage;
      this.getPageAppointByWhile();
    },        
  },
};
</script>


<style scoped>
>>> .btnSelect span{
  width: 60px;
  word-break:normal; 
  display:block; 
  white-space:pre-wrap;
  word-wrap : break-word ;
}
>>> .el-button--small {
  height: 32px;
  padding: 0;
}

.teacherInfo {
  overflow: hidden;
}
.teacherInfo .el-icon-arrow-right {
  position: absolute;
  top: 50%;
  right: 10px;
}

.el-pagination {
  text-align:center;
  position: fixed;
  bottom: 80px;
  width: 100%;
}
</style>
